import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Icon } from 'semantic-ui-react';
import { formatDate } from '@/utils/dateHelper';
import { validationResultStatusIconProps } from '../helper';

const DictionaryValidationResultButton = ({
  dataExists,
  disabled,
  onClick,
  validationDate,
  validationStatus,
  rowCount,
}) => {
  const intl = useIntl();
  const formattedDate = validationDate ? formatDate(validationDate) : null;
  const iconProps = validationResultStatusIconProps(validationStatus, dataExists);

  return (
    <Button
      className="dataset-dictionary-validation-result-button pe-auto"
      disabled={disabled}
      onClick={disabled ? null : onClick}
      data-tooltip={intl.formatMessage({ id: iconProps.message }, { date: formattedDate })}
      data-position="left center"
    >
      <Icon
        name={iconProps.name}
        color={iconProps.colour}
        alt={intl.formatMessage({ id: iconProps.message }, { date: formattedDate })}
      />
      {rowCount && (<FormattedMessage id="dataset.dictionary.rows.count" values={{ count: rowCount }} />)}
    </Button>
  );
};

export default DictionaryValidationResultButton;
